import { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { Box, Grid, Typography } from '@mui/material';
import AssetIcon from '@/components/Job/JobTabs/JobTabAssetStatus/AssetIcon';

type SchemaFormatBoxProps = PropsWithChildren & {
  label: string;
};

const SchemaFormatBox = ({ label, children }: SchemaFormatBoxProps) => {
  return (
    <Grid container item xs={12} alignItems="flex-start">
      <StyledGridBox container>
        <StyledIconLabel container item xs={4} md={5} lg={4} xl={3}>
          <AssetIcon type={label} />
          <Box>
            <label>{label}</label>
          </Box>
        </StyledIconLabel>
        <StyledGridChildren container item xs={8} md={7} lg={8} xl={9}>
          {children || <Typography variant="caption">-</Typography>}
        </StyledGridChildren>
      </StyledGridBox>
    </Grid>
  );
};

export default SchemaFormatBox;

const StyledGridBox = styled(Grid)(({ theme }) => ({
  padding: 0,
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  margin: 0,
  minHeight: 47,
  width: '100%',
  maxWidth: '600px',
  marginBottom: theme.spacing(1),
  spacing: 0,
  gap: 0,
  '& label': {
    textTransform: 'capitalize',
    fontWeight: theme.typography.fontWeightBold,
    opacity: 0.6
  },
  '& .MuiBox-root': {
    background: 'none',
    border: 0,
    padding: 0,
    margin: 0
  },
  '&.media': {
    '&, & svg': {
      color: theme.palette.primary.main
    }
  },
  '&.audio': {
    '&, & svg': {
      color: theme.palette.secondary.main
    }
  }
}));

const StyledIconLabel = styled(Grid)(({ theme }) => ({
  flexWrap: 'nowrap',
  alignItems: 'center',
  height: 47,
  padding: theme.spacing(0, 2, 0, 1),
  '&.MuiGrid-root': {
    maxWidth: 110
  }
}));

const StyledGridChildren = styled(Grid)(({ theme }) => ({
  display: 'flex',
  minHeight: 47,
  padding: theme.spacing(1, 1, 1, 2),
  borderLeft: `1px solid ${theme.palette.action.hover}`
}));
